import { useLayoutEffect, useRef } from "react";
import { router } from "@inertiajs/react";

// Where the scroll pane was when a visit to the same page started. Kept
// outside the component, because the visit unmounts the page that saved it.
let savedScroll: number | null = null;

// Changing a picker reloads the page, which rebuilds the scroll pane at the
// top. Remember where the pane was before a visit to `path` (the page's own
// path, no query) and put it back once the page has mounted again. Visits to
// other pages scroll as usual. Put the returned ref on the page's root
// element; its parent is the scroll pane.
export function useKeepScroll(path: string) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const pane = ref.current?.parentElement;
    if (!pane) return;
    if (savedScroll != null) {
      const top = savedScroll;
      savedScroll = null;
      pane.scrollTop = top;
      // Again after the charts have measured themselves.
      requestAnimationFrame(() => { pane.scrollTop = top; });
    }
    return router.on("before", (event) => {
      const visit = event.detail.visit;
      // A visit that keeps the page mounted keeps the pane too: nothing to put back.
      if (visit.preserveState === true) return;
      if (visit.url.pathname === path) savedScroll = pane.scrollTop;
    });
  }, [path]);

  return ref;
}
